import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';

export const AdminLayout = loadable(() => import('./admin.layout'), {
  fallback: <FullPageLoader />,
});
